export var AppStateActions;
(function (AppStateActions) {
  let SetConnectionError = /*#__PURE__*/(() => {
    class SetConnectionError {
      static {
        this.type = '[Page] SetConnectionError';
      }
      constructor(isError = true) {
        this.isError = isError;
      }
    }
    return SetConnectionError;
  })();
  AppStateActions.SetConnectionError = SetConnectionError;
  let SetChunkError = /*#__PURE__*/(() => {
    class SetChunkError {
      static {
        this.type = '[Page] SetChunkError';
      }
      constructor(isError = true) {
        this.isError = isError;
      }
    }
    return SetChunkError;
  })();
  AppStateActions.SetChunkError = SetChunkError;
})(AppStateActions || (AppStateActions = {}));